const WoodLogCountingTypes = {
    CLEAR_ERROR: "CLEAR_ERROR",
    FETCH_WOODLOG_COUNTING_START: "FETCH_WOODLOG_COUNTING_START",
    FETCH_WOODLOG_COUNTING_SUCCESS: "FETCH_WOODLOG_COUNTING_SUCCESS",
    FETCH_WOODLOG_COUNTING_FAILURE: "FETCH_WOODLOG_COUNTING_FAILURE",
}

export default WoodLogCountingTypes;